import Template from '../../component/Template';
import { useEffect } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React, { useRef } from "react";
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';



export default function Coursemapping() {// CHECKING IF USER IS VALID
    const [message, setMessage] = useState(false);
    const [discipline, setDisciplineData] = useState([]);
    const [faculty, setFacultyData] = useState([]);


    const [facultyname, setFacultyname] = useState(false); //23/3/2024

    const { http } = Api();
    const [showModal, setShowModal] = useState(false);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [facultyChange, setFacultyChange] = useState([]);
    const [disciplineChange, setDisciplineChange] = useState([]);
    const [activeTab, setActiveTab] = useState('tab1');
    const [semesterID, setSemester] = useState(null);

    const openHourModal = (course) => {
        setSelectedCourse(course);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setSelectedCourse(null);
    };

    const navigate = useNavigate();

    const encodeID = id => {
        return btoa(id);
    };  
    const encodeSemID = semid => {
        return btoa(semid);
    };

    // For dynamic row in each tab
    const [tabRows, setTabRows] = useState({
        tab1: [{ id: 1 }],
        tab2: [{ id: 1 }],
        tab3: [{ id: 1 }],
        tab4: [{ id: 1 }],
        tab5: [{ id: 1 }],
        tab6: [{ id: 1 }],
        tab7: [{ id: 1 }],
        tab8: [{ id: 1 }]
    });

    const getCoursesByFacultyAndDiscipline = async (facultyId, disciplineId, activeTab) => {


        try {
            setMessage(false);
            const response = await http.get(`/Admin/syllabuslisting`, {
                params: {
                    discipline_id: disciplineId,
                    semester: semesterID || null
                }
            });

            const coursesBySemester = {};
            response.data.data.forEach(course => {
                if (!coursesBySemester[course.semester_id]) {
                    coursesBySemester[course.semester_id] = [];
                }
                coursesBySemester[course.semester_id].push(course);
            });
            //console.log("coursesBySemester"+coursesBySemester);
            setTabRows({
                tab1: coursesBySemester[1] || [],
                tab2: coursesBySemester[2] || [],
                tab3: coursesBySemester[3] || [],
                tab4: coursesBySemester[4] || [],
                tab5: coursesBySemester[5] || [],
                tab6: coursesBySemester[6] || [],
                tab7: coursesBySemester[7] || [],
                tab8: coursesBySemester[8] || [],
            });
        } catch (error) {
            setMessage("Something went wrong");
            console.error('Error fetching course data:', error);
        }
    };

    const handleFacultyAndDisciplineChange = () => {
        const facultyId = document.getElementById('faculty_id').value;
        const disciplineId = document.getElementById('discipline_id').value;

        setFacultyChange(facultyId);
        setDisciplineChange(disciplineId);
        if (facultyId) {
            isdisiplin();
        }

        getCoursesByFacultyAndDiscipline(facultyId, disciplineId, activeTab);
    };
    useEffect(() => {
        getCoursesByFacultyAndDiscipline(facultyChange, disciplineChange, activeTab);

    }, [facultyChange, disciplineChange, activeTab])

    const Row = ({ rows, tab }) => (
        <>
            <div className="table-responsive sem-course-credit">

                <table className="display dataTable table-striped table-bordered">
                    <thead className="tab-wt">
                        <tr className="bg-primary text-white">
                            <th rowSpan="2" className="text-center align-middle">Course Code</th>
                            <th rowSpan="2" className="text-center align-middle">Course & Specialisation</th>
                            <th rowSpan="2" className="text-center align-middle">Type of the Course</th>
                            <th rowSpan="2" className="text-center align-middle">Credit</th>
                            <th className="text-center align-middle">Hour Distribution</th>
                            <th className="text-center align-middle">Action</th>
                        </tr>
                    </thead>

                    {rows.map(course => {

                        return (
                            <tbody key={course.courseid}>
                                <tr>
                                    <td>{course.course_code}</td>
                                    <td>{course.course_name}
                                    <br />
                                        {course.specialisation_name && course.specialisation_name !== '-' && (
                                            <>
                                                <span style={{ color: "green", fontWeight: "600", fontSize: "12px" }}>
                                                 Specialisation -
                                                </span>
                                                <span style={{ color: "green", fontWeight: "600",fontSize: "12px"  }}>
                                                    {course.specialisation_name}
                                                </span>
                                            </>
                                        )}
                                        </td>
                                    <td>{course.course_discipline_component_code}</td>
                                    <td className="text-center">{course.credit}</td>

                                    <td className="text-center" style={{ verticalAlign: "middle" }}>
                                        <i
                                            className="bi bi-info-circle-fill hour-info-icon icn-out-bod"
                                            onClick={() => openHourModal(course)}
                                            title="Hour Distribution"
                                        ></i>
                                    </td>

                                    <td style={{ verticalAlign: "middle" }}>
                                        <ul className="action" style={{ margin: 0, padding: 0 }}>
                                            <li className="edit" style={{ listStyle: "none" }} >
                                                <Link to={`/admin/courseedit/${encodeID(course.courseid)}/${encodeSemID(course.semester_id)}`} title="Edit" target="_blank">
                                                    <i className="icon-pencil-alt icn-out-bod"
                                                    style={{
                                                        cursor: "pointer",
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        lineHeight: "1"
                                                    }}
                                                    ></i>&nbsp;
                                                    {/* Edit */}

                                                </Link>
                                            </li>
                                            <li className="edit" style={{ listStyle: "none" }}>
                                                <Link to={`/admin/courseview/${encodeID(course.courseid)}`} target="_blank">
                                                    <i className="bi bi-file-earmark icn-out-bod" title="View" 
                                                    style={{
                                                        cursor: "pointer",
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        lineHeight: "1"
                                                    }}></i>
                                                </Link>
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                            </tbody>
                        );
                    })}
                </table>

                {/* ===================== MODAL ===================== */}

                {showModal && selectedCourse && (
                    <div className="sem-course-credit custom-modal-backdrop">

                        <div className="sem-course-credit custom-modal">

                            <div className="sem-course-credit modal-header p-10">
                                <h5>Hour Distribution - {selectedCourse.course_code}</h5>
                                <button onClick={closeModal} className="sem-course-credit close-btn">×</button>
                            </div>

                            <div className="sem-course-credit modal-body">

                                <table className="sem-course-credit modal-table">
                                    <thead className="bg-primary text-white">
                                        <tr>
                                            <th>Component</th>
                                            <th className="text-center">Credit</th>
                                            <th className="text-center">Hours</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {selectedCourse.CourseComponents.map(comp => {

                                            const codeMap = {
                                                "L": "lecture",
                                                "T": "tutorial",
                                                "PCP": "practicum",
                                                "PLP": "practical",
                                                "FW": "fieldwork",
                                                "S": "seminar",
                                                "A": "assignment",
                                                "O": "OJT",
                                                "INT": "internship"
                                            };

                                            const key = codeMap[comp.course_component_code] ||
                                                comp.course_component_code.toLowerCase();

                                            const credit = selectedCourse.CreditHours[`${key}_credit`] ?? 0;
                                            const hours = selectedCourse.CreditHours[`${key}_hours`] ?? 0;

                                            return (
                                                <tr key={comp.id}>
                                                    <td>{comp.course_component}</td>
                                                    <td className="text-center">{credit}</td>
                                                    <td className="text-center">{hours}</td>
                                                </tr>
                                            );
                                        })}
                                        {/* ======= LAST ROW: TOTAL ======= */}
                                        <tr className="bg-light-row">
                                            <td>Total</td>
                                            <td className="text-center">
                                                {selectedCourse.credit}
                                            </td>
                                            <td className="text-center">
                                                {selectedCourse.total_hours}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                {/* <div className="sem-course-credit total-hours">
                                    <div>Total Hours: <strong>{selectedCourse.CreditHours.total_hours}</strong></div>
                                </div> */}

                            </div>
                        </div>
                    </div>
                )}

            </div>

        </>
    );



    useEffect(() => {
        const { http } = Api();


        const fetchData = async () => {
            try {

                setMessage("initial");
                // const response = await http.get(`/Admin/getspecialisation`);
                const response1 = await http.get(`/Admin/getfaculty`);
                //const response2 = await http.get(`/Admin/getdiscipline`);
                const response2 = await http.get(`/Admin/getdiscipline`, {
                    params: {
                        limit: '500'
                    }
                });

                setDisciplineData(response2.data.data);
                setFacultyData(response1.data.data);


            } catch (error) {

                setMessage("somthing went wrong");
                console.error('Error fetching discipline data:', error);

            }
        };

        fetchData();

    }, []);


    const isAuth = useAuth();

    if (isAuth === false) {
        navigate("/admin/")
    }

    const isdisiplin = () => {
        const faculty_id = document.getElementById('faculty_id').value;
        const selectedFaculty = faculty.find(facultys => parseInt(facultys.id) === parseInt(faculty_id));
        setFacultyname(selectedFaculty.id);


    }

    //for tab
    //const [activeTab, setActiveTab] = useState('tab1');

    const handleTabClick = (tabName) => {
        setActiveTab(tabName);
        const sem = parseInt(tabName.replace("tab", ""), 10);
        setSemester(sem);
    };

    return (
        <>
            <ToastContainer />
            <Template>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12" >
                            <div className="card">
                                <div className="col-md-12">
                                    <div className="card-header">
                                        <div className="py-3 d-flex justify-content-between align-items-center ">
                                            <h5>Sem-Wise Course</h5>
                                        </div>
                                    </div>
                                    <div className="card-body">

                                        <div className="card-body pdg">
                                            <div className="table-responsive">



                                                <div className="card-body custom-input">

                                                    <div className="row">
                                                        <div className="col">

                                                            <div className="mb-3 row">
                                                                <div className="col-md-6">
                                                                    <label className="">Faculty Name</label>

                                                                    <select className="form-control scrollable-bar-select" id="faculty_id" name="faculty_id" onChange={handleFacultyAndDisciplineChange} required>
                                                                        <option value={0} >Select Faculty</option>

                                                                        {faculty.map(facultys => (

                                                                            <option value={facultys.id}  >{facultys.faculty_name}</option>
                                                                        ))}

                                                                    </select>
                                                                </div>
                                                                <div className="col-md-6">

                                                                    <label className="">Discipline</label>
                                                                    <select className="form-control scrollable-bar-select" id="discipline_id" onChange={handleFacultyAndDisciplineChange} name="discipline_id" required>
                                                                        <option value={0}>Select Discipline</option>
                                                                        {discipline.map(disciplines => (
                                                                            disciplines.faculty_id == facultyname && (
                                                                                <option key={disciplines.id} value={disciplines.id}>{disciplines.discipline_name}</option>
                                                                            )
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            {message ? (
                                                                <div className="alert " style={{ width: '50%', margin: 'auto', marginTop: '20px', textAlign: 'center', fontSize: '20px' }}>Data not available</div>
                                                            ) : (
                                                                <>
                                                                    < br ></br>


                                                                    <ul className="nav nav-tabs justify-content-center">
                                                                        <li className="nav-item">
                                                                            <a
                                                                                className={`nav-link ${activeTab === 'tab1' ? 'active selected-tab' : ''}tab-link`}
                                                                                onClick={() => handleTabClick('tab1')}

                                                                            >
                                                                                Sem 1
                                                                            </a>
                                                                        </li>
                                                                        <li className="nav-item">
                                                                            <a
                                                                                className={`nav-link ${activeTab === 'tab2' ? 'active selected-tab' : ''}tab-link`}
                                                                                onClick={() => handleTabClick('tab2')}

                                                                            >
                                                                                Sem 2
                                                                            </a>
                                                                        </li>
                                                                        <li className="nav-item">
                                                                            <a
                                                                                className={`nav-link ${activeTab === 'tab3' ? 'active selected-tab' : ''}tab-link`}
                                                                                onClick={() => handleTabClick('tab3')}

                                                                            >
                                                                                Sem 3
                                                                            </a>
                                                                        </li>
                                                                        <li className="nav-item">
                                                                            <a
                                                                                className={`nav-link ${activeTab === 'tab4' ? 'active selected-tab' : ''}tab-link`}
                                                                                onClick={() => handleTabClick('tab4')}

                                                                            >
                                                                                Sem 4
                                                                            </a>
                                                                        </li>
                                                                        <li className="nav-item">
                                                                            <a
                                                                                className={`nav-link ${activeTab === 'tab5' ? 'active selected-tab' : ''}tab-link`}
                                                                                onClick={() => handleTabClick('tab5')}

                                                                            >
                                                                                Sem 5
                                                                            </a>
                                                                        </li>
                                                                        <li className="nav-item">
                                                                            <a
                                                                                className={`nav-link ${activeTab === 'tab6' ? 'active selected-tab' : ''}tab-link`}
                                                                                onClick={() => handleTabClick('tab6')}

                                                                            >
                                                                                Sem 6
                                                                            </a>
                                                                        </li>
                                                                        <li className="nav-item">
                                                                            <a
                                                                                className={`nav-link ${activeTab === 'tab7' ? 'active selected-tab' : ''}tab-link`}
                                                                                onClick={() => handleTabClick('tab7')}

                                                                            >
                                                                                Sem 7
                                                                            </a>
                                                                        </li>
                                                                        <li className="nav-item">
                                                                            <a
                                                                                className={`nav-link ${activeTab === 'tab8' ? 'active selected-tab' : ''}tab-link`}
                                                                                onClick={() => handleTabClick('tab8')}

                                                                            >
                                                                                Sem 8
                                                                            </a>
                                                                        </li>
                                                                    </ul>
                                                                    <div className="tab-content mt-3" style={{ border: '1px solid #ccc', padding: '30px', backgroundColor: 'rgba(242, 243, 247, 0.7)' }}>
                                                                        <div className={`tab-pane ${activeTab === 'tab1' ? 'active' : ''}`}>
                                                                            SEMESTER 1
                                                                            <div className="table-responsive">
                                                                                <Row rows={tabRows.tab1} tab="tab1" />
                                                                            </div>
                                                                        </div>
                                                                        <div className={`tab-pane ${activeTab === 'tab2' ? 'active' : ''}`}>
                                                                            SEMESTER 2
                                                                            <div className="table-responsive">
                                                                                <Row rows={tabRows.tab2} tab="tab2" />
                                                                            </div>
                                                                        </div>

                                                                        <div className={`tab-pane ${activeTab === 'tab3' ? 'active' : ''}`}>
                                                                            SEMESTER 3
                                                                            <Row rows={tabRows.tab3} tab="tab3" />

                                                                        </div>
                                                                        <div className={`tab-pane ${activeTab === 'tab4' ? 'active' : ''}`}>
                                                                            SEMESTER 4
                                                                            <Row rows={tabRows.tab4} tab="tab4" />

                                                                        </div>
                                                                        <div className={`tab-pane ${activeTab === 'tab5' ? 'active' : ''}`}>
                                                                            SEMESTER 5
                                                                            <Row rows={tabRows.tab5} tab="tab5" />

                                                                        </div>
                                                                        <div className={`tab-pane ${activeTab === 'tab6' ? 'active' : ''}`}>
                                                                            SEMESTER 6
                                                                            <Row rows={tabRows.tab6} tab="tab6" />

                                                                        </div>
                                                                        <div className={`tab-pane ${activeTab === 'tab7' ? 'active' : ''}`}>
                                                                            SEMESTER 7
                                                                            <Row rows={tabRows.tab7} tab="tab7" />

                                                                        </div>
                                                                        <div className={`tab-pane ${activeTab === 'tab8' ? 'active' : ''}`}>
                                                                            SEMESTER 8
                                                                            <Row rows={tabRows.tab8} tab="tab8" />
                                                                        </div>
                                                                        {/* Add more tab panes as needed */}
                                                                    </div>


                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </Template >
        </>
    );
}
